module.exports = __webpack_public_path__ + "img/googleplay.1e91d02c.png";